import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=b9aaaef6&scoped=true&lang=pug&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=b9aaaef6&prod&lang=sass&scoped=true&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=b9aaaef6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aaaef6",
  null
  
)

/* custom blocks */
import block0 from "./Detail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports